/* eslint-disable */
const getters = {
  getVideos(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
